export type ProofreadingSelectTypeEntry =
  | { kind: "waiting" }
  | { kind: "new" }
  | { kind: "dialog"; canResumeAiRevise: boolean };

export function classifyProofreadingSelectTypeEntry(params: {
  aiBatchStatus: string | null;
  hasAiReviseResult: boolean;
  workManuscriptIds: string[];
}): ProofreadingSelectTypeEntry {
  if (params.aiBatchStatus === "RUNNING") {
    return { kind: "waiting" };
  }

  const canResumeAiRevise =
    params.hasAiReviseResult || params.aiBatchStatus === "COMPLETED";
  if (canResumeAiRevise || params.workManuscriptIds.length > 0) {
    return { kind: "dialog", canResumeAiRevise };
  }

  return { kind: "new" };
}

/**
 * ダイアログ未選択では新規開始しない。破棄（no）だけカードを解放する。
 */
export function canStartNewProofreadingAfterDialog(
  action: "yes" | "no" | undefined,
): boolean {
  return action === "no";
}
